import { AlreadyQuotation } from './AlreadyQuotation';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

type HaveQuotationProps = {
  setShowHaveQuotation: Function;
  setIsHeroAction: Function;
};

export const HaveQuotationWrapper = ({
  setShowHaveQuotation,
  setIsHeroAction,
}: HaveQuotationProps) => {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isDesktop = useMediaQuery(breakpoints.down('lg'));

  return (
    <Box
      sx={{
        backgroundColor: '#F2FAFC',
        padding: isMobile ? '28px' : isDesktop ? '72px' : '55.5px 150px',
      }}
    >
      <AlreadyQuotation padding={16} elevation={12} isAbsolute={false} />
      <Typography
        onClick={() => {
          setShowHaveQuotation(false);
          setIsHeroAction(true);
        }}
        sx={{
          textAlign: 'center',
          marginTop: '24px',
          color: '#039ECC',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        No tengo número de cotización
      </Typography>
    </Box>
  );
};
